// Gemeinsamer Supabase-Client für alle Seiten.
//
// Die Werte kommen aus der .env (Präfix VITE_). Sie landen im Bundle und sind
// damit öffentlich — genau dafür ist der anon key gedacht. Der eigentliche
// Zugriffsschutz liegt in den RLS-Policies.

import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !key) {
  throw new Error(
    "VITE_SUPABASE_URL oder VITE_SUPABASE_ANON_KEY fehlt. " +
      "Lege eine .env im Projektwurzelverzeichnis an (Vorlage: .env.example).",
  );
}

export const supabaseClient = createClient(url, key);

// Der Legacy-Code greift durchgehend auf das globale _supabase zu.
window._supabase = supabaseClient;

export default supabaseClient;
